<div class="container">
  <mat-tab-group [selectedIndex]="selected.value" (selectedTabChange)="selected.setValue($event.index)">
    <mat-tab label="Histórico Orden de Compra">
      <div  class="mt-4">
        <data-table
          [titleExcelFile]="'histórico_orden_de_compra'"
          [columns]='columnsPO'
          [configuration]='configurationPO'
          [reloadTable]='reloadTablaPO'
          [params]="[{id: 'active', value: 1}]"
          [url]='urlTablePO'
          (add)='addPO($event)'
          (edit)='editarPO($event)'
          (delete)='eliminarPO($event)'
          (view)='viewDetail($event)'
          (sendEmail)='sendEmail($event)'
          (exportXslxByRow)='exportXslxByRow($event)'
          (print)="print($event)"
          [headerFilters]="headerFilters"
          [headerFileXlsm]="headerFileXlsm"
        ></data-table>

      </div>
    </mat-tab>

    @if (selected.value == 1 || selected.value == 2) {
      <mat-tab label="Detalle">
        <div style="width: 100%">
          <app-button-label [labelsEdit]="labels">
          </app-button-label>
          <data-table
            [titleExcelFile]="'detalle_orden_de_compra_' + labels[0].value"
            [columns]="columnsDetails"
            [data]="dataDetails"
            [configuration]="configurationDetails"
            [reloadTable]="reloadTablaDetails"
            [headerFileXlsm]="headerDetailsFileXlsm"
            >
          </data-table>
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</div>
